import { useTranslation } from 'react-i18next'

import { ClockIcon } from '@phosphor-icons/react'

import AnimatedNumber from '@/common/components/AnimatedNumber/AnimatedNumber'
import Statistic from '@/common/components/Statistic/Statistic'

import { transactionsAnalyticsStatsValues } from '../constants'

const PendingApproval = ({ pendingApproval, onClick }) => {
  const { t } = useTranslation()

  return (
    <Statistic
      size="small"
      isOutlined={false}
      Icon={ClockIcon}
      label={t('Pendientes aprobación')}
      value={<AnimatedNumber target={pendingApproval} format="decimal" />}
      onClick={() => onClick(transactionsAnalyticsStatsValues.pendingApproval)}
    />
  )
}

export default PendingApproval
